<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <!-- Куки  -->
    <div id="cookie" v-if="show">
        <div class="cookie-popup">
            <div id="cookie-close" @click="show = false">&times;</div>
            <div class="cookie-container">
                <div>
                    В целях анализа посещаемости и улучшения работы сайта мы используем сервис "Яндекс.Метрика".<br />
                    Оставаясь на нашем сайте, Вы выражаете свое
                    <a href="Согласие_на_обработку_персональных_данных.pdf" target="_blank">согласие</a> на
                    <a href="Политика_обработки_персональных_данных.pdf" target="_blank">обработку</a> Ваших данных
                    указанным сервисом.
                </div>
                <button id="cookie-to-accept" class="btn" @click="toAcceptCookie()">{{ btn_name }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            btn_name: "Принять",
            show: false,
            cookie: localStorage.getItem("cookie") ?? false,
        };
    },
    methods: {
        toAcceptCookie() {
            this.show = false;
            localStorage.setItem("cookie", true);
        },
    },
    mounted() {
        if (this.cookie) {
            this.show = false;
        } else {
            setTimeout(() => {
                this.show = true;
            }, 2000);
        }
    },
};
</script>

<style lang="scss">
.cookie-popup {
    position: fixed;
    bottom: 20px;
    right: 0;
    left: 0;
    z-index: 999;
    width: fit-content;
    height: auto;
    background: #fff;
    font-size: 14px;
    line-height: 20px;
    color: #000;
    margin: auto;
    box-shadow: 0 0 5px rgb(0, 0, 0, 0.5);
    border-radius: 20px;
    @media (max-width: 768px) {
        margin: 0 15px;
    }
    p {
        white-space: pre-line;
        @media (max-width: 768px) {
            white-space: unset;
        }
        a {
            text-decoration: underline;
            color: inherit;
        }
    }
    .cookie-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 10px 20px;
        text-align: center;
        @media (max-width: 768px) {
            font-size: 12px;
            padding: 0 10px 10px;
            text-align: left;
        }
        a {
            color: inherit;
            text-decoration: underline;
            &:hover,
            &:focus {
                color: #333;
                transition: 0.2s ease 0.2s;
            }
        }
    }
}
#cookie-close {
    display: flex;
    justify-content: flex-end;
    font-size: 18px;
    cursor: pointer;
    position: relative;
    top: 5px;
    right: 10px;
}
#cookie-to-accept {
    width: fit-content;
    height: 35px;
    padding: 0 20px;
    font-size: 14px;
    margin-top: 10px;
    @media (max-width: 768px) {
        height: 25px;
        font-size: 12px;
        margin-top: 5px;
    }
}
</style>
